module.exports = __webpack_public_path__ + "static/media/CK.0ebbf747.png";